</<template>
    <div class='mask'>
       <div class='user_agreement'>
         <div class='content'>
            <h3 class="userneed_tit">星罗优惠商品推广服务协议</h3>
            <p>  特别提醒：在确认同意本协议之前，您（以下称“甲方”）应事先了解本协议条款的全部内容，同意与青岛星罗创想网络科技有限公司（以下简称“乙方”）进行推广服务合作。本协议连同所有更新材料、补充条款以及本协议相关网络页面、软件客户端等（包括但不限于“什么值得买”网站、app等）载明的其他规则和政策共同构成了甲乙双方之间的协议。
            </p>
            <p>
                甲方应在审慎阅读本协议的全部条款、充分理解各条款内容（尤其是以“加粗及下划线”方式进行标识的条款，因为这些条款可能会明确甲方应履行的义务或对甲方的权利有所限制）后再进行后续的操作。若甲方确认签署本协议，即表示甲方同意接受本协议条款约束。
            </p>
            <p>
              甲乙双方根据《广告法》及有关法律、法规之规定，就甲方在包含但不限于“什么值得买”（www.smzdm.com）网站发布推广信息事宜，达成协议如下：
            </p>
            <h4>1、推广信息发布</h4>
            <p>1.1 乙方根据本协议约定向甲方提供发布推广信息的增值服务，甲方可根据自身需求向乙方提供优惠商品活动信息，由乙方发布在包含但不限于“什么值得买”（www.smzdm.com）网站上，
              甲方应保证前述优惠商品的合法、真实、有效性，并明确优惠商品的优惠类型和时限。进行推广信息发布。乙方在受理甲方需求后，将按照本协议的约定和乙方的审核标准进行审核，并在审核
              通过后按照甲方所申请提报的顺序进行排序推广。具体推广显示时间、推广服务内容及推广位置以“什么值得买”（www.smzdm.com）网站规定为准。
            </p>
            <h4>2、推广费用和支付方式</h4>
            <p>2.1甲方知晓并同意，本协议项下每一申请提报的优惠商品推广信息的推广费用，按照乙方推广的该条信息实际产生的服务费结算（服务费计算方式：
              销售额*服务费比例，其中服务费比例以星罗平台提交时约定的服务费比例为准），包含但不限于“什么值得买”（www.smzdm.com）平台产生。实际推广数据
              以甲方所在平台商家后台数据为准（包含但不仅限于淘宝、京东等平台）
            </p>

            <p>2.2推广费用支付方式：甲方在每一申请提报活动期结束后一次性支付推广费用。 </p>

            <p>2.3甲方可向乙方申请开具等额有效增值税专用发票或普通发票，发票内容为信息服务费。甲方在乙方开具发票后如在360天内没有税务认证，乙方不负责退票或换票，由此所造成的损失由甲方自行承担。 </p>

            <p>2.4双方各自承担按照有关法律法规和国家政策规定由各方应缴纳的税费。 </p>

            <h4>3、双方的权利和义务</h4>
            <p>3.1甲方应提供真实有效的推广数据给乙方，乙方有权要求用包含但不限于拍照、视频等方式验证甲方结算数据真实性，一旦发现甲方存在作弊、欺诈等行为，乙方有权要求甲方按照实际损失的2倍进行赔偿。 </p>

            <p>3.2甲方应当保证推广信息真实、有效、合法，保证推广信息不违反任何法律、法规、政策及公共道德准则，不包含任何木马、病毒等有害内容，也不会 侵害任
              何第三方的合法权益。如甲方违反此保证，致使乙方及/或其关联方（包括但不限于“什么值得买”网站、app的所属方，下同）蒙受任何损失，甲方应向乙方提供全面足额的赔偿。
            </p>

            <p>3.3乙方有权审查甲方提供的推广信息。对不符合法律、法规规定，或涉嫌侵犯第三方合法权益，或给乙方带来不利影响的推广信息，乙方有权要求甲方进行修改，在甲方按照乙
              方要求完成修改前，乙方有权拒绝发布该推广信息且不视为违约。对于已经发布但事后发现或被举报不符合法律、法规规定，或涉嫌侵犯第三方合法权益，或对乙方及/或其关联方带来不利影响的推广信息，
              乙方有权根据相关法律法规的要求并结合实际情况对相关内容采取删除、屏蔽、断开链接等处理措施，且有权追究甲方的法律责任，如因此给乙方及/或其关联方造成损失的，甲方应负责赔偿。
            </p>

            <p>3.4乙方不对推广信息承担任何责任，也不承诺推广信息的具体效果。如因虚假信息和产品质量等问题产生任何纠纷，由甲方自行负责解决并承担全部责任，因此给乙方及/或其关联方造成任何损失的，甲方均应承担赔偿责任。 </p>

            <h4>4、特殊免责情况</h4>
            <p>4.1鉴于互联网广告所具有的网络技术和网络媒体之特殊性质而产生的包括黑客攻击、电信部门技术调整导致的影响、因政府管制而造成的暂时性关闭、服务器宕机、网站停机
              维护等在内的任何影响网络正常经营的因素造成推广投放计划的延误，乙方及/或其关联方对此延误不承担违约责任。 
            </p>

            <p>4.2乙方按本协议规定投放推广信息后，因计算机、手机等网络终端客户自行对其网络终端进行设置而导致甲方投放的推广无法在该用户的网络终端显示的，不视为乙方违约，乙方及/或其关联方不承担任何责任。 </p>

            <h4>5、知识产权</h4>
            <p>5.1甲方保证对其所提供的在推广过程中使用的文字、图片等推广信息及素材享有合法的使用权，不存在任何权利瑕疵或负担。甲方授予乙方及/或其关联方在履行本协议目的下对推广信息及素材的使用权、修改权、信息网络传播权等。</p>

            <p>5.2甲方同意，乙方有权在不影响甲方提供的推广信息原文整体意思的前提下，根据实际需要自行修改文章标题，以及删减或修改部分内容的文字表述等，其他规则另有规定的除外。乙方保证其任何编辑、修改均不会故意歪曲、篡改用户表达的
              原意，或故意使用任何可能引发侵权的内容。根据本项规定进行修改后的内容依旧代表甲方的观点，乙方不为修改后的文章和内容承担任何法律和经济上可能产生的纠纷。如甲方发现乙方编
              辑、修改后的内容与甲方的原意相违背或者可能导致任何侵权纠纷的，甲方可及时以有效方式通知乙方，乙方将采取适当处理措施。
            </p>
            <h4>6、违约责任</h4>
            <p>为保障甲方（即“商家”）、用户以及乙方及什么值得买网站（SMZDM.COM）（以下称“什么值得买”）的正当权益，维持市场正常运营秩序，“什么值得买”平台（含网站、app等，下同）将对违规商家采取以下处理措施： </p>

            <p>（1）暂停活动审核： </p>

            <p>a.商家有严重违规行为时，“什么值得买”有权暂停活动审核。 </p>

            <p>b.实际信息与提报描述不符时，“什么值得买”有权暂停活动审核。/p>

            <p>（2）黑名单 </p>

            <p>a.严重违规行为，“什么值得买”有权将违规商家拉入黑名单。 </p>

            <p>b.商家不配合“什么值得买”的售后处理，辱骂、嘲讽、贬低“什么值得买”处理人员的，“什么值得买”有权直接将违规商家拉入黑名单。 </p>

            <p>备注： </p>

            <p>“暂停活动审核”是指商家报名的商品暂停审核及发布。 </p>

            <p>“严重违规行为”，包括但不限于虚假提报、严重客服问题投诉或无客服、普遍性的商品质量问题等损害用户、其他商家以及“什么值得买”权益的行为。 </p>
            <p>“拉入黑名单”是指商家发生违规行为并且性质严重时，“什么值得买”有权对其进行强制性清退处理，终止与商家的一切合作，删除商家在“什么值得买”平台的所有信息并永久禁止商家再次入驻。</p>
            <p>以上内容，由“什么值得买”提供解释和咨询服务，并可能根据市场情况定期修改更新，更新后内容将以邮件形式进行通知，如商家在3日内未提出异议的视为同意更新后内容。</p>

            <h4>7、反商业贿赂</h4>
            <p>7.1甲方应保证甲方及其任何员工不得给予乙方及/或其关联方任何员工直接或间接的不正当利益（如在账外暗中向乙方任何员工支付任何佣金、报酬或给予回扣）。  </p>

            <p>7.2如甲方知悉乙方及/或其关联方员工有接受上述不正当利益的，甲方可向乙方以下邮箱进行举报：neishen@smzdm.com。 </p>
            <h4>8、不可抗力</h4>

            <p>8.1“不可抗力”是指甲乙双方不能合理控制、不可预见或即使预见亦无法避免的事件，该事件妨碍、影响或延误任何一方根据协议履行其全部或部分义务。该事件包括但不限于政府行为、自然灾害、战争、黑客攻击、计算机病毒（如木马程序、蠕虫等）、电信部门技术性调整或任何其它类似事件。 </p>

            <p>8.2出现不可抗力事件时，受影响方应及时、充分地以书面形式通知对方，并告知对方该类事件对本协议可能产生的影响，并应当在合理期限（不可抗力事件发生后 30 日）内提供该等事件的详细信息及由有关组织出具的解释受影响方因此无法履行全部或部分本协议项下义务的相关证明。 </p>
            <p>8.3由于以上所述不可抗力事件致使协议的部分或全部不能履行或延迟履行，则甲乙双方于彼此间不承担任何违约责任。</p>

            <h4>9、争议解决与适用法律</h4>
            <p>9.1凡因签署、履行本协议书过程所发生的或与本协议书有关的一切争议或纠纷，双方应通过友好协商解决。如在协商开始后三十日内双方仍不能解决该争议，则任何一方均有权就该争议或纠纷向乙方所在地有管辖权的人民法院提起诉讼。 </p>

            <p>9.2本协议的订立、效力、解释、履行和争议的解决均应适用中华人民共和国法律。 </p>

            <h4>10、其他约定</h4>


            <p>10.1甲方签署本协议即表示接受本协议（包括但不限于所有更新材料、补充条款以及本协议相关网络页面、软件客户端等载明的其他规则和政策）全部内容，本协议立即对双方生效，双方应严格遵守本协议全部约定。 </p>

            <p>10.2无论因何种原因（包括不限于违反法律法规）导致本协议任何条款完全或部分无效或不具有执行力，不影响本协议任何其他条款的效力、合法和可执行性。 </p>

            <img src="../../assets/login/close.png" alt="" class="close_img" @click='closeMask'>
            </div>
       </div>
    </div>
</template>
<style scope>
.mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top:0;
    left:0;
    background: rgba(0,0,0,.5);
    z-index: 5;
  }
   .userneed_tit {
    font-size: 20px;
    color:#303133;
    text-align: center;
    margin: 0;
  }
  .user_agreement {
    width: 865px;
    height: 800px;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    padding: 41px 30px 0 30px;
    font-size: 14px;
    box-sizing: border-box;
  }
  .content {
    height: 750px;
    overflow: auto;

  }
  .close_img {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
</style>
<script>
export default {
    name: 'agreement',
    methods:{
        closeMask(){
            this.$emit('closeMask')
        },
    }
}
</script>